'use strict';

module Patersons {
    export class UserPreferences {
        pan: string = '';
        skipMobileRegistration: boolean = false;

        public static load(pan: string): UserPreferences {
            let prefsString: string = localStorage.getItem(UserPreferences.preferenceKeyName(pan));
            let prefs: UserPreferences = JSON.parse(prefsString) as UserPreferences || new UserPreferences();
            prefs.pan = pan;
            return prefs;
        }

        public save(): void {
            let prefsString: string = JSON.stringify(this, this.jsonReplacer);
            localStorage.setItem(UserPreferences.preferenceKeyName(this.pan), prefsString);
        }

        private static preferenceKeyName(pan: string): string {
            return `Patersons.Preferences.${pan}`;
        }

        private jsonReplacer(key, value): any {
            if (key == 'pan') {
                return undefined;
            } else {
                return value;
            }
        }
    }
}
